import React from 'react';

const RULES = [
  { icon: 'bi-camera-fill', text: 'Photo is required for Check-in and Check-out.' },
  { icon: 'bi-clipboard-check-fill', text: 'You must complete a daily declaration after Check-out.' },
  { icon: 'bi-clock-fill', text: 'Declare Minus or Overtime hours with a reason.' },
  { icon: 'bi-person-fill', text: 'TOIL is managed separately (see TOIL module).' },
];

const KeyEmployeeRules = ({ onClose }) => (
  <div
    style={{
      position: 'absolute',
      top: '100%',
      right: 0,
      marginTop: 8,
      width: 320,
      maxWidth: '90vw',
      background: '#fff8e6',
      border: '1px solid #f4e3ab',
      borderRadius: 12,
      padding: '16px 18px',
      boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
      zIndex: 1050,
    }}
  >
    <div className="d-flex align-items-center justify-content-between mb-3">
      <span className="fw-bold" style={{ color: '#a8790a' }}>
        <i className="bi bi-shield-check me-1" />Key Employee Rules
      </span>
      <button
        type="button"
        className="btn-close"
        style={{ fontSize: 12 }}
        aria-label="Close"
        onClick={onClose}
      />
    </div>
    <div className="d-flex flex-column gap-3">
      {RULES.map((r, idx) => (
        <div key={idx} className="d-flex align-items-start gap-2">
          <i className={`bi ${r.icon}`} style={{ color: '#c98f0a', fontSize: 18, marginTop: 2 }} />
          <span className="small text-dark">{r.text}</span>
        </div>
      ))}
    </div>
  </div>
);

export default KeyEmployeeRules;
